// extracted by mini-css-extract-plugin
export default {"category":"qQ4SsW0mN_vAYuY3F11w","open":"xM5c4K5dL41f5ZTMiEsV"};